import CTNButton from '@ctn/ui/components/ctn-button';
import styleCustomProps from '@ctn/ui/components/ctn-utils/styleCustomProps';
import { type CTNButtonProps } from '@ctn/ui/types/ctn-button';
import classNames from 'classnames';
import React, { useCallback, useMemo } from 'react';

type EntityGroupProps = {
	readonly className?: string;
	readonly hasError: boolean;
	readonly children: React.ReactElement;
	readonly action: Pick<CTNButtonProps, 'onClick' | 'label'>;
	readonly counterTxt: string;
	readonly isShowChildren?: boolean;
	readonly title: string;
};

const classNameComponent = 'c-pnp-entity-group';

const EntityGroup = ({
	className,
	hasError,
	children,
	action,
	title,
	isShowChildren = true,
	counterTxt,
}: EntityGroupProps) => {
	const classNameEntityGroup = useMemo(() => classNames(className, classNameComponent, 'u-mt-16'), [className]);

	const stylesEntityGroup = useCallback(
		({ hasError }: { hasError: boolean }) =>
			styleCustomProps({
				[`--${classNameComponent}--borderColor`]: { value: hasError ? 'red-50' : 'gray-40' },
				[`--${classNameComponent}--backgroundColor`]: { value: hasError ? 'red-10' : 'white-100' },
			}),
		[],
	);

	return (
		<section className={classNameEntityGroup} style={stylesEntityGroup({ hasError })}>
			<header className="o-splitter o-splitter--responsive">
				<div>
					<h5 className={`${classNameComponent}__tit`}>{title}</h5>
					<p className={`${classNameComponent}__counter`}>{counterTxt}</p>
				</div>
				<CTNButton
					mode="secondary"
					label={action.label}
					size="size-40"
					onClick={action.onClick}
				/>
			</header>
			{isShowChildren && <div className="u-mt-24 u-mt-8@portrait">{children}</div>}
		</section>
	);
};

export default EntityGroup;
